import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';

const LandingPage = () => {
    const navigate = useNavigate();
    const [timeLeft, setTimeLeft] = useState(5);

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft((prev) => prev - 1);
        }, 1000);

        const redirect = setTimeout(() => {
            navigate('/home');
        }, 5000);

        return () => {
            clearInterval(timer);
            clearTimeout(redirect);
        };
    }, [navigate]);

    return (
        <div className="min-h-screen bg-neutral-900 flex flex-col items-center justify-center text-white p-4">
            <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.8 }}
                className="text-center"
            >
                <div className="flex justify-center mb-6">
                    <Sparkles className="w-16 h-16 text-yellow-400" />
                </div>
                <h1 className="text-5xl font-bold mb-4 bg-clip-text text-transparent bg-gradient-to-r from-yellow-200 to-yellow-500">
                    Relatos de Papel
                </h1>
                <p className="text-xl text-neutral-400 mb-8">
                    Tu puerta a mundos infinitos.
                </p>

                <div className="w-64 h-1 bg-neutral-800 rounded-full mx-auto overflow-hidden">
                    <motion.div
                        className="h-full bg-yellow-400"
                        initial={{ width: "0%" }}
                        animate={{ width: "100%" }}
                        transition={{ duration: 5, ease: "linear" }}
                    />
                </div>

                <p className="mt-4 text-sm text-neutral-500">
                    Entrando en {timeLeft} segundos...
                </p>
            </motion.div>
        </div>
    );
};

export default LandingPage;
